import { collection, query, where, getDocs, getDoc, addDoc, updateDoc, doc, deleteDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { COLLECTIONS } from '../../constants/collections';

// Fallback collection name if not in constants
// Fallback collection name if not in constants
const DOCK_COLLECTION = 'docks';

const getCollectionPath = (tenantId) => `tenants/${tenantId}/${DOCK_COLLECTION}`;

export const getDockById = async (dockId, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        const docRef = doc(db, getCollectionPath(tenantId), dockId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
        }
        return null;
    } catch (error) {
        console.error('Error fetching dock by ID:', error);
        return null;
    }
};

export const getDocks = async (tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        const q = query(
            collection(db, getCollectionPath(tenantId))
        );
        const snapshot = await getDocs(q);

        // Ensure standard format
        return snapshot.docs.map(doc => ({
            id: doc.id,
            name: doc.data().name || 'İsimsiz Rampa',
            type: doc.data().type || 'general',
            status: doc.data().status || 'active', // active, maintenance
            ...doc.data()
        }));
    } catch (error) {
        console.error('Error fetching docks:', error);
        return [];
    }
};

export const createDock = async (dockData, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        await addDoc(collection(db, getCollectionPath(tenantId)), {
            ...dockData,
            tenantId,
            createdAt: Timestamp.now(),
            status: 'active'
        });
    } catch (error) {
        console.error('Error creating dock:', error);
        throw error;
    }
};

export const updateDockStatus = async (dockId, status, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        await updateDoc(doc(db, getCollectionPath(tenantId), dockId), {
            status,
            updatedAt: Timestamp.now()
        });
    } catch (error) {
        console.error('Error updating dock status:', error);
        throw error;
    }
};
